<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-expand-transition>
			<div v-if="!submitting_address">
				<div v-if="step >= $const.STEP_SHIPPING_ADDRESS">
					<div class="section-title">
						<h2 class="active" v-if="step === $const.STEP_SHIPPING_ADDRESS" v-bind="ADAattr('h1')" aria-level="2">
							Select Shipping Address
						</h2>
						<h2 v-else v-bind="ADAattr('h1')" aria-level="2">
							Shipping Address
						</h2>


						<v-flex xs12 v-if="show_extra_info" class="co-extra-layout">
							<v-card flat>
								<extra-checkout-info
										:data="extra_info"
										v-if="extra_info['shown']"
										show-in-shipping-address="true"
								></extra-checkout-info>
							</v-card>
						</v-flex>


						<div v-if="step > $const.STEP_SHIPPING_ADDRESS && !disableEditing">
							<a
								href="#"
								class="co-change-link"
								@click.prevent="$emit('change-step', $const.STEP_SHIPPING_ADDRESS)"
								v-bind="ADAattr('button', 'Change shipping address')"
							>
								{{ step === $const.STEP_SHIPPING_ADDRESS ? 'Close' : 'Change' }}
							</a>
						</div>

						<div v-if="contacts.is_ou_coursepack" class="ou-coursepack-text">Enter the mailing address where you’d like to receive your materials.
							If you are ordering digital material or material that will be picked up on campus, this address will not be used,
							but it is a requirement to place the order.</div>

					</div>

					<div class="co-contacts-sections co-contacts-sections-brief pt-2" v-if="step > $const.STEP_SHIPPING_ADDRESS">
						<ul>
							<li class="cob-address">
								<div><strong>{{ formatAddressLabel(address) }}</strong></div>
								<div>{{ formatAddress(address, ' ', 'distinct') }}</div>
							</li>
							<li class="cob-email">
								<strong>{{ contacts.email }}</strong>
							</li>
							<li class="cob-send-info">
								<v-checkbox
										label="It's okay to send me information, communication, and notices from the bookstore via email or text message."
										v-model="subscribe"
										:disabled="disableEditing"
										hide-details
										class="mt-0"
								>
								</v-checkbox>
							</li>
						</ul>
					</div>

					<div class="co-contacts-sections" v-if="step === $const.STEP_SHIPPING_ADDRESS">
						<v-layout row>
							<v-flex xs12>
								<v-card align-start flat>
									<v-card-text class="px-4 py-0">
										<v-radio-group v-model="selected_idx" class="co-contacts-container-radio-group">
											<div class="co-contacts-container">

                        <div v-for="(type, index) in shipping_addresses_order">
                          <div v-if="type == 'home'">
                            <template v-if="!athlete_campuses_only && is_split_addresses">
                              <div class="pt-4 pb-1 subheading co-text-highlight" :class="{ 'mt-2': index === 0 }">
                                <v-icon class="mr-1">local_shipping</v-icon>
                                <strong>Ship to Home</strong>
                              </div>
                            </template>

                            <scroll-list v-if="!athlete_campuses_only && home_addresses.length" :items="3">
                              <div v-for="addr in home_addresses" :key="addr.idx">
                                <shipping-address-option
                                  :address="addr"
                                  :selected="selected_idx === addr.idx"
                                  :editing="editing_idx === addr.idx"
                                  :saving="is_saving_address"
                                  :disable_apo_states="disable_apo_states"
                                ></shipping-address-option>
                              </div>
                            </scroll-list>

                            <shipping-address-option
                              v-if="!athlete_campuses_only && (!guest || !addresses.length)"
                              label="Add Shipping Address"
                              :address="add_address"
                              :selector="addresses.length"
                              :editing="editing_idx === add_address.idx"
                              :saving="is_saving_address"
                              :disable_apo_states="disable_apo_states"
                              :class="{'grey--text': selected_idx !== add_address.idx}"
                              off-icon="add_circle"
                            ></shipping-address-option>
                          </div>

                          <div v-if="type == 'campus'">
                            <template v-if="is_split_addresses">
                              <div class="pt-4 subheading co-text-highlight" :class="{'pb-1': !campus_addresses_disabled, 'mt-2': index === 0}">
                                <v-icon class="mr-1">local_shipping</v-icon>
                                <strong>Ship to Campus</strong>
                              </div>
                              <div v-if="campus_addresses_disabled" class="co-text-highlight body-1 pb-1" v-html="campus_addresses_disabled" v-bind="ADAattr('focus')"></div>
                            </template>

                            <scroll-list v-if="campus_addresses.length" :items="3">
                              <div v-for="addr in campus_addresses" :key="addr.idx">
                                <shipping-address-option
                                  :address="addr"
                                  :selected="selected_idx === addr.idx"
                                  :editing="editing_idx === addr.idx"
                                  :saving="is_saving_address"
                                  :disable_apo_states="disable_apo_states"
                                ></shipping-address-option>
                              </div>
                            </scroll-list>
                          </div>
                        </div>

											</div>
										</v-radio-group>
									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</div>

					<div class="co-alt-email-section" v-if="step === $const.STEP_SHIPPING_ADDRESS && can_continue">
						<v-layout row>
							<v-flex xs12>
								<v-card align-start flat>
									<v-card-text class="px-4 pt-0">
										<div class="co-alt-email-selector">
											<div v-bind="ADAattr('hidden')"><strong>Information about your order will be sent to this email address:</strong></div>

											<div class="py-3" role="heading" aria-level="3" v-bind="[ADAattr('focus'), ADAattr('label', `Information about your order will be sent to this email address: ${contacts.email}`)]">
												<strong v-bind="ADAattr('hidden')">{{ contacts.email }}</strong>
											</div>

											<div>
												<v-checkbox
														label="Send a copy of order information to a different email address as well (optional)."
														v-model="send_copy"
														hide-details
														class="mt-0"
												></v-checkbox>
											</div>
											<div id="alt_email_sl">
												<div tabindex="0" class="mt-0">
														Set an additional email address for my account (This email will get copies of all emails sent to your account)
												</div>
											</div>

											<v-text-field
													v-model="alt_email"
													:rules="alt_email_rules"
													label="Enter email address"
													class="co-text-field mt-0"
													v-show="send_copy"
											></v-text-field>

										</div>

										<div>
											<v-checkbox
													label="It's okay to send me information, communication, and notices from the bookstore via email or text message."
													v-model="subscribe"
													class="my-0 pt-2"
											>
											</v-checkbox>
										</div>


										<div class="co-custom-fields-section"
											 v-if="$globs['custom_fields'] && $globs['custom_fields']['status'] !== 'disabled'">
											<h3 :class="{ 'co-text-highlight': $globs['custom_fields']['status'] === 'required' }" v-bind="ADAattr('focus')">
												{{ $globs['custom_fields']['label'] }}
											</h3>

											<div class="co-custom-fields-content" v-html="$globs['custom_fields']['instructions']" v-bind="ADAattr('focus')"></div>
											<div class="co-custom-fields-input">
												<v-form
														v-model="user_field_form_valid"
														ref="user_field_form"
												>
													<v-text-field
															v-model="user_field"
															counter="25"
															:rules="user_field_rules"
															class="co-text-field"
															:label="$globs['custom_fields']['label']"
													></v-text-field>
												</v-form>
											</div>
										</div>

										<v-divider v-bind="ADAattr('hidden')"></v-divider>

									</v-card-text>
								</v-card>
							</v-flex>
						</v-layout>
					</div>

					<div class="co-submit-panel" v-if="step === $const.STEP_SHIPPING_ADDRESS && can_continue">
						<v-btn
								color="#2170f2"
								:loading="submitting_address"
								:dark="!submitting_address"
								id="btn-checkout-step-shipping-address"
								@click="submit(); ADAfocus(`#ada-ea-${selected_idx}`)"
								v-bind="ADAattr('button-readonly', submitting_address, 'Continue to shipping method')"
						>
							Continue
						</v-btn>
					</div>

				</div>
				<div v-else class="co-section-todo" v-bind="ADAattr('hidden')">
					<h2>
						Shipping Address
					</h2>
					<p>
						Select Shipping Address
					</p>
				</div>
			</div>
		</v-expand-transition>

		<v-expand-transition>
			<div v-if="submitting_address">
				<div class="co-submit-address">
					<v-progress-linear :indeterminate="true" v-bind="ADAattr('progress', 'Saving shipping address')"></v-progress-linear>
				</div>
			</div>
		</v-expand-transition>

	</div>

</template>

<script>
	import ScrollList from '../../common/components/vuejs/ScrollList';
	import ShippingAddressOption from './ShippingAddressOption';
	import ExtraCheckoutInfo from "./ExtraCheckoutInfo";
	import Vuetify from 'vuetify';
	import 'vuetify/dist/vuetify.min.css';
	import _ from 'lodash';

	import Axios from 'axios';
	import {formatAddressLabel, formatAddress, isUSA} from './../includes/Miscellaneous';

	class Address {
		constructor(vue, idx, data = {}) {
			const self = this;

			self.vue = vue;

			const props = ['idx', 'id', 'name', 'line1', 'line2', 'city', 'state', 'postal_code',
        'country', 'phone', 'is_mobile', 'campus_address', 'source', 'label', 'can_be_used', 'pickup_location_id'];

			const defaults = {
				idx,
				id: 0,
				country: 'US',
				source: 'checkout',
				is_mobile: false,
				campus_address: false,
        pickup_location_id: null,
				can_be_used: true,
			};

			_.each(props, (p) => {
				const value = _.get(data, p, _.get(defaults, p, ''));
				self[p] = value === '' && p in defaults ? defaults[p] : value;
			});

			self.can_be_used = self.can_be_used && self.vue.isAllowedState(self.state) && self.vue.isAllowedCountry(self.country) && self.vue.canBeUsedForShipping(self.country);

			self.edit = () => {
				self.vue.selected_idx = self.idx;
				self.vue.editing_idx = self.idx;
			};

			self.onEdit = (payload) => {
				self.vue.$emit('editing-address', payload);
			};

			self.save = async (addr) => {
				self.vue.is_saving_address = true;

				if (self.vue.isCampusAddress(self)) {
					addr = addr.fetch();
				} else {
					addr = await addr.validate();
				}

				if (addr === null) {
					self.vue.is_saving_address = false;
					return;
				}

				self.vue.$emit('save', {id: self.id, ...addr, pickup_location_id: self.pickup_location_id});
			};

			self.cancel = () => {
				self.vue.editing_idx = null;
			};
		}
	}

	export default {
		name: "ShippingAddress",

		components: {
			ScrollList,
			ShippingAddressOption,
			ExtraCheckoutInfo
		},

		props: {
			guest: {
				type: Boolean,
				default: false,
			},
			disableEditing: {
				type: Boolean,
				default: false,
			},
			disable_apo_states: {
				type: Boolean,
				default: false,
			},
			contacts: {
				type: Object,
			},
			step: {
				type: Number,
			},
			preselected_idx: {
				default: null,
			},
			saving_address: {
				type: Boolean,
				default: false,
			},
			submitting_address: {
				type: Boolean,
				default: false,
			},
			extra_info:{
				type: Object,
			},
			show_extra_info: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				is_saving_address: false,
				selected_idx: null,
				editing_idx: null,
				subscribe: true,
				alt_email: '',
				send_copy: false,

				user_field_form_valid: null,
				user_field: null,
				user_field_rules: [
					value => !this.$globs['custom_fields'] || this.$globs['custom_fields']['status'] !== 'required' || (!!value && !!value.trim && !!value.trim()) || 'Required.',
				],
				email_rules: [
					value => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return (!!value && !!value.trim && !!value.trim() && pattern.test(value)) || 'Invalid e-mail.';
					},
				],
				alt_email_rules: [
					value => {
						const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						return !value || !value.trim || value.trim() === '' || pattern.test(value) || 'Invalid e-mail.';
					},
				],
			};
		},

		watch: {
			preselected_idx: {
				immediate: true,
				handler(idx) {
					this.selected_idx = _.isInteger(idx) ? idx : null;
				},
			},

			address: {
				immediate: true,
				handler(selected) {
					if (this.editing_idx !== _.get(selected, 'idx', null)) {
						this.editing_idx = null;
					}
					if (selected !== null) {
						if (!selected.can_be_used) {
							this.$nextTick(() => this.selected_idx = null);
						} else if (selected.id === 0) {
							selected.edit();
						}
						if (selected.can_be_used) {
							this.$emit('selected-address-changed', selected);
						}
					}
				},
			},

			saving_address(value) {
				this.is_saving_address = value;
			},
		},

		mounted() {
			const self = this;
			self.subscribe = self.contacts.subscribe;
			self.alt_email = self.contacts.alt_email;
			self.send_copy = !!self.alt_email;

			self.$watch('subscribe', function (value, old) {
				self.$emit('subscribe-changed', {
					subscribe: value,
				});
			});

			if(this.$globs['checkout_preferences']['address'] === 'campus' && this.campus_addresses.length > 0) {
				this.selected_idx = this.campus_addresses[0].idx; //TODO: this is tbd with Paul
			}
		},

		methods: {
			formatAddressLabel,
			formatAddress,
			isUSA,

			submit() {
				const self = this;

				if (self.$globs['custom_fields'] && self.$globs['custom_fields']['status'] === 'required' && self.$refs.user_field_form) {
					if (!self.$refs.user_field_form.validate()) {
						return null;
					}
				}

				const addr = self.addresses[self.selected_idx];
				self.$emit('submit', {
					data: {
						address_id: addr.id,
						country: addr.country,
						state: addr.state,
					},
					user_field: self.user_field,
					alt_email: self.send_copy ? self.alt_email : '',
				});
			},

			isAllowedState(state) {
				return !this.disable_apo_states || !this.$globs['apo_states'].includes(state);
			},

			isAllowedCountry(country) {
				return this.isUSA(country) || !this.$globs['disable_international_shipping'];
			},

			isCampusAddress(addr) {
				return addr.campus_address == true || addr.source === 'campus_dropdown';
			},

			canBeUsedForShipping(country) {
				if (!this.$globs['is_international']) {
					return this.isUSA(country);
				}
				return true;
			},
		},

		computed: {
		  shipping_addresses_order() {
        return this.$globs['checkout_preferences']['address'] === 'campus' ? ["campus", "home"] : ["home", "campus"]
      },

			addresses() {
				return _.isEmpty(this.contacts.addresses) ? [] : _.map(
					this.contacts.addresses, (data, idx) => new Address(this, idx, data)
				);
			},

			address() {
				return this.selected_idx === null ? null : (
					this.addresses[this.selected_idx] || this.add_address
				);
			},

			add_address() {
				return new Address(this, -1);
			},

			home_addresses() {
				if (this.athlete_campuses_only) return [];
				return _.filter(this.addresses, addr => {
					return !this.isCampusAddress(addr);
				});
			},

			campus_addresses() {
				return _.filter(this.addresses, addr => {
					return this.isCampusAddress(addr);
				});
			},

			athlete_campuses_only() {
				return this.$globs['athlete_campuses_only'];
			},

			is_split_addresses() {
				return !_.isEmpty(this.campus_addresses);
			},

			campus_addresses_disabled() {
				return !_.every(this.campus_addresses, {can_be_used: false}) ? null : (
					'Shipping to campus is not available at this time.'
				);
			},

			can_continue() {
				return this.selected_idx in this.addresses && this.editing_idx === null;
			},
		},
	};
</script>

<style scoped lang="less">
	.co-contacts-sections {
		padding: 0 0 0 0px;

		/deep/ .co-contacts-container-radio-group {
			width: 100%;
			margin-top: 0;

			> .v-input__control {
				flex-grow: 1;

				> .v-messages {
					min-height: 0;
				}
			}
		}

		.co-contacts-container {
			width: 100%;
		}

		&.co-contacts-sections-brief {
			> ul {
				list-style: none;
				margin: 0;
				padding: 0 0 0 24px;

				> li {
					font-size: 16px;
					padding: 5px 0;
				}
			}
		}
	}

	.ou-coursepack-text {
		border-top: 1px solid #E0E0E0;
		padding-top: 10px;
		padding-bottom: 10px;
		margin-top: 10px;
	}

	/deep/ .co-alt-email-section {
		.v-text-field {
			width: 250px;

			input {
			}

			.v-label {
				top: 6px !important;
			}
		}

		.co-alt-email-selector {
			padding-top: 20px;
		}

		.v-messages {
			min-height: 0;
		}
	}

	.co-custom-fields-section {
		border-top: 1px solid #E0E0E0;

		margin: 10px 0 0 0;
		padding: 10px 0;

		> h3 {
			font-size: 19px;
			margin: 10px 0;
		}
	}

	.co-submit-address {
		padding: 30px 32px 20px;

		h4 {
			font-weight: normal;
			font-style: italic;
			font-size: 18px;
		}
	}

	.co-extra-layout {
	  float: left !important;
	}

</style>
